import { FaCheckSquare as CheckIcon } from 'react-icons/fa';

export default CheckIcon;
